/**
 *
 * @module playbackAttributes
 *
 */

/**
 *
 * @class PlaybackAttributes
 * @since 3.2.0
 * @desc Contains information about the playlist streams.
 * @note Constructed based on `SDK.Services.Media.MediaPayload` attributes.
 *
 */
export default class PlaybackAttributes {

    /**
     *
     * @param {String} adPartner
     * @param {Array<SDK.Services.Media.DrmType>} [drms=[]]
     * @param {String} encryptionType
     * @param {Array<String>} [audioSegmentTypes=[]]
     * @param {Array<String>} [videoSegmentTypes=[]]
     *
     */
    constructor(adPartner, drms = [], encryptionType, audioSegmentTypes = [], videoSegmentTypes = []) {

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets the ad partner ID.
         *
         */
        this.adPartner = adPartner;

        /**
         *
         * @access public
         * @type {Array<SDK.Services.Media.DrmType>}
         * @desc Gets the list of DRMs supported by this content.
         *
         */
        this.drms = drms;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.encryptionType = encryptionType;

        /**
         *
         * @access public
         * @type {Array<String>}
         *
         */
        this.audioSegmentTypes = audioSegmentTypes;

        /**
         *
         * @access public
         * @type {Array<String>}
         *
         */
        this.videoSegmentTypes = videoSegmentTypes;

    }

}




// WEBPACK FOOTER //
// ./src/media/playbackAttributes.js